var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.platform.site",
  title: "EGT Platform — Site & Profiles",
  description: "A presence you own — fast, beautiful, brand-aware pages, profiles, and media.",
  supportServer: true,
  fields: { reserveUrl: { title: "Reserve URL", type: "uri", description: "Reservation entry point.", required: false } }
});
var P = require("../helpers/egt.platform.sections.js");

exports.render = async function render(options) {
  var reserve = (options && options.reserveUrl) || "/reserve";
  return P.capabilityPage({
    id: "site", reserve: reserve,
    media: { video: "/vis/identities.mp4", poster: "/vis/identities.jpg", width: "1920", height: "1080", parallax: 0.06 },
    eyebrow: "The Universe Platform · Site",
    title: [ "A presence ", { n: "br" }, "you ", { n: "span", c: "egt__gold", i: "own." } ],
    lead: "Pages, profiles, and media that look like you and load before they blink — held in one place you control, not rented from a page-builder.",
    /* SEO wave 2C-5/2C-7 (2026-10-09): answer-first definition, who it's for,
     * and straight answers drawn only from objections the site already answers. */
    answer: "Site & Profiles is the website part of the Universe Platform by EGT — your pages, profiles and media under your own brand and domain, for a business that wants a site it owns rather than rents from a page-builder. It's part of the public beta.",
    forTitle: "For anyone whose site should be a front door, not a rental.",
    forWho: [
      { title: "Businesses outgrowing a page-builder", copy: "Keep your pages, profiles, media and domain in a system you own, instead of rebuilding them every time a builder changes the rules." },
      { title: "Brands that won't look like a template", copy: "Your colors, type and voice carry through every page automatically, so the site looks like you from the first page." },
      { title: "Owners who'd rather not tune for speed", copy: "Pages are built to arrive fast, everywhere — speed isn't a project you have to schedule." }
    ],
    faq: [
      [ "Can I bring my domain and keep my URLs?",
        "Yes. Point your domain, keep your existing URLs, and stay fast and crawlable from day one — so your rankings come with you instead of resetting." ],
      [ "Is the site separate from my store and email?",
        "No. It's the front of the same system: your store, your customers and your message are all reachable from the same presence." ],
      [ "Can I export my data and leave?",
        "Yes. Your customers, orders, content and email list are yours, held as a grant, not a copy. Export them and walk anytime — an integrated core shouldn't mean a locked door." ]
    ],
    spineEyebrow: "What it does",
    spineTitle: "Yours, fast, and unmistakably you.",
    spineLead: "A site isn't a brochure bolted onto your business — it's the front of the same system that runs everything else.",
    points: [
      { title: "You own it", copy: "Your pages, your profiles, your media, your domain — held in the system you own, not locked inside someone else's builder." },
      { title: "Brand-aware by default", copy: "Your colors, type, and voice run through every page automatically — because branding is the foundation, not a finishing step." },
      { title: "Fast on purpose", copy: "Speed isn't a setting you switch on later. The whole system was built so pages arrive instantly, everywhere." }
    ],
    honesty: "One front door for everything you do.",
    honestyLead: "Your store, your customers, your message — all reachable from the same presence, because they're all the same system.",
    honestyMedia: { img: "/imgs/egt-platform-canvas.jpg", alt: "", parallax: true }
  });
};
